import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme/colorThemes.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UIProvider } from './components/UIProvider';
import AppErrorBoundary from './components/AppErrorBoundary';
import { installNumberInputGuard } from './utils/numberInputGuard';

installNumberInputGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <UIProvider>
        <App />
      </UIProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
